<!-- UniPost component Builder -->

<template>
	<div class="bld-unipost">
		<div class="title wi8_font">UniPost Builder</div>

		<button @click="setStep('current')">Current</button> &nbsp;
		<button @click="setStep('upload')">Upload</button>  &nbsp;
		<button @click="setStep('contact')">Contact</button> &nbsp;
		<button @click="setStep('sweep')">Sweep</button> &nbsp;
		<button @click="setStep('stats')">Stats</button> &nbsp;

		<br />
		<button @click="setTrx('clear')">Trx Clear</button> &nbsp;
		<button @click="setTrx('wait')">Trx Wait</button> &nbsp;
		<button @click="setTrx('succ')">Trx Succ</button> &nbsp;
		<button @click="setTrx('fail')">Trx Fail</button> &nbsp;

		<br />
		<button @click="setWait(true)">Wait On</button> &nbsp;
		<button @click="setWait(false)">Wait Off</button> &nbsp;

		<div class="v-spacer"></div>

		<div class="content">
			<UniPost 
				:compData="compData"
			/>
		</div>

	</div>
</template>

<script>
import { m } from "@/utils/utils.js";
export default {
	data() {
		return {
			compData: {
				step: "stats",
				autoPost: false,
			},
			statusList: {
				clear:	{trx:"clear", mess:[]},
				wait:	{trx:"wait", mess:["waiting"]},
				succ:	{trx:"100", mess:["Upload success", "Thanks for posting"]},
				fail:	{trx:"201", mess:[
					"Upload error", 
					"Database error", 
					"Duplicate key", 
					"Please contact your application adminitrator. Hours are Mon - Fri 9:00am - 5:00pm"]},
			},
		}
	},
	methods: {

		setTrx(mode) {

			let payload = this.statusList[mode];
			payload.step = this.compData.step;

			m("bld uni post set trx " + mode, payload);

			this.$store.dispatch("app/updTrxStatus", payload);
		},

		setWait(val) {
			m("set wait " + val);
			if (val) {
				this.$store.dispatch("api/toggleWait");
			} else {
				this.$store.dispatch("api/toggleWait", "clear");
			}
		},
		setStep(step) {
			m("set step " + step);
			this.compData.step = step;
		},
	},
}
</script>

<style scoped>
.bld-unipost {
	height: 100%;
	overflow: hidden;
	background-color: #FCFCEE;
	border: solid 0px #C30;
}

.title {
	height: 30px;
	color: #690;
	border: solid 0px #369;
}

.content {
	height: calc(100% - 110px);
	border: solid 0px #090;
}

.v-spacer {
	width: 10px;
	height: 10px;
	overflow: hidden;
	border: solid 0px #C30;
}

button {
	width: 80px;
}


</style>
